import { toast } from 'sonner'
import { FaCheck } from 'react-icons/fa6'

export default function AlertSuccess(text = 'Save successfully.') {
  toast.success(text, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    icon: (
      <div
        className="ms-1"
        style={{
          backgroundColor: '#01E17B',
          width: 24,
          height: 24,
          display: 'flex',
          padding: '7px',
          justifyContent: 'center',
          alignItems: 'center',
          flexShrink: 0,
          borderRadius: 8,
        }}
      >
        <FaCheck
          style={{ color: 'var(--color-on-primary-content-high)' }}
          size={22}
        />
      </div>
    ),
    style: {
      fontFamily: '"Prompt", sans-serif',
      color: '#263146',
      fontWeight: 500,
      border: '1px solid #01E17B',
      backgroundColor: '#E5FCF1',
      borderRadius: '16px',
      gap: '18px',
    },
  })
}
